import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getChartStoreData = (state: StateScheme) => {
    return state.finance.chartStoreData
}
